import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45f0da59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm:px-4 px-10 flex justify-between" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Website Disclaimer")
const _hoisted_3 = { class: "flex px-6 sm:px-0 flex sm:flex-row flex-col mt-6" }
const _hoisted_4 = { class: "px-4 w-full" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Website ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-between flex-row mt-4 cursor-pointer",
  style: {"line-height":"1.8"}
}, " The information contained in this website is for general information purposes only. The information is provided by Bartin Coin, a property of BartingCoin. While we endeavour to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk. In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website. Through this website you are able to link to other websites which are not under the control of BartingCoin. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them. Every effort is made to keep the website up and running smoothly. However, BartingCoin takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control. ", -1))
const _hoisted_7 = { style: {"display":"flex","justify-content":"end"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Agree ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_label = _resolveComponent("ps-label")!
  const _component_ps_button = _resolveComponent("ps-button")!
  const _component_ps_modal = _resolveComponent("ps-modal")!

  return (_openBlock(), _createBlock(_component_ps_modal, {
    ref: "psmodal",
    line: "hidden",
    bodyHeight: "max-h-110",
    maxWidth: "1000px",
    isFullscreen: true,
    isClickOut: true,
    class: "z-50"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ps_label, { class: "font-medium lg:text-3xl text-xl" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ps_label, {
            textColor: "text-primary-500 dark:text-primaryDark-accent",
            class: "font-medium lg:text-xs text-xxs"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ps_button, {
              onClick: _ctx.AgreeClicked,
              class: "flex h-7"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => []),
    _: 1
  }, 512))
}